import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ProductType,
    OrderSubType,
} from 'app/enums/label.enums'

import {
    PoolingFields,
} from '../pooling.types'

const config: SkyNetTableConfig<PoolingFields> = {
    name: 'Pooling.ContainerSelection',
    tabs: [{
        name: 'Upcoming Container Selection',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                width: '100px',
            },
            {
                name: 'from',
                filterField: 'from',
                filterType: FilterType.Array,
                width: '135px',
            },
            {
                name: 'to',
                filterField: 'to',
                filterType: FilterType.Array,
                width: '170px',
            },
            {
                name: 'orderSubType',
                filterField: 'orderSubType',
                componentName: 'EnumValue',
                filterType: FilterType.Array,
                allowedValuesEnum: OrderSubType,
            },
            {
                name: 'originLocationLocationName',
                filterField: 'originLocationLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationLocationLocationName',
                filterField: 'destinationLocationLocationName',
                filterType: FilterType.Array,
            },
            {
                name: 'plannedPickup',
                filterField: 'plannedPickup',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
            },
            {
                name: 'requiredContainers',
                componentName: 'RequiredContainersList',
                allowedValuesEnum: ProductType,
                filterField: 'requiredContainersContainerModel',
                filterType: FilterType.Array,
                sorting: false,
            },
            {
                name: 'containerSelectionUntilUtc',
                componentName: 'ContainerSelectionUntil',
                headerProps: {
                    children: 'Remaining / Overdue',
                },
            },
        ],
    }],
}

export default config
